import { Component } from '@angular/core';

@Component({
	selector: 'app-offers-scan-manage',
	templateUrl: './offers-scan-manage.component.html',
	styleUrls: ['./offers-scan-manage.component.css'],
})
export class OffersScanManageComponent {
	constructor() {}
}
